import React, { useRef, useState } from 'react';

import { SideMenuCondition } from '../../../store/reducers/studentSideMenuReducer';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';

import './MenuPanel.scss';

interface IMenuPanelProps {
  sideMenuCondition: SideMenuCondition;
  children: React.ReactNode;
}

export const MenuPanel = ({ sideMenuCondition, children }: IMenuPanelProps) => {
  const [initialTransition] = useState(sideMenuCondition);
  const menuPanelRef = useRef(null);

  const animateOnInit = () => {
    if (initialTransition === SideMenuCondition.expanded) {
      return true;
    }

    return undefined;
  };

  return (
    <CSSTransition
      nodeRef={menuPanelRef}
      in={animateOnInit()}
      timeout={{ appear: 700 }}
      classNames="menu-panel--transition"
    >
      <div
        ref={menuPanelRef}
        className={classNames('menu-panel', {
          'menu-panel--collapsed': sideMenuCondition === SideMenuCondition.collapsed,
          'menu-panel--hidden': sideMenuCondition === SideMenuCondition.buttonHidden,
        })}
      >
        {children}
      </div>
    </CSSTransition>
  );
};
